var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_842_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.606 12.2242C23.606 11.2409 23.5256 10.5234 23.3517 9.7793H12.043V14.2173H18.6809C18.5472 15.3202 17.8245 16.9811 16.2185 18.0972L16.196 18.2458L19.7716 20.996L20.0193 21.0205C22.2944 18.9344 23.606 15.8649 23.606 12.2242Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0452 23.9176C15.2972 23.9176 18.0274 22.8545 20.0215 21.0209L16.2207 18.0976C15.2036 18.8018 13.8385 19.2934 12.0452 19.2934C8.86004 19.2934 6.15668 17.2074 5.193 14.324L5.05175 14.3359L1.33378 17.1927L1.28516 17.3269C3.26583 21.2334 7.33431 23.9176 12.0452 23.9176Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19259 14.324C4.93832 13.58 4.79116 12.7826 4.79116 11.9589C4.79116 11.135 4.93832 10.3378 5.17921 9.59366L5.17248 9.43519L1.40792 6.53247L1.28475 6.59064C0.468414 8.21174 0 10.0322 0 11.9589C0 13.8855 0.468414 15.7059 1.28475 17.327L5.19259 14.324Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0452 4.62403C14.3069 4.62403 15.8326 5.59402 16.7025 6.40461L20.1018 3.10928C18.0141 1.1826 15.2972 0 12.0452 0C7.33431 0 3.26583 2.68406 1.28516 6.59056L5.17962 9.59359C6.15668 6.7102 8.86004 4.62403 12.0452 4.62403Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_842_360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.6ec73c3b07206488dd030b495e7a7efd.svg";
export { ForwardRef as ReactComponent };